import { z } from 'zod'

// the full account_totals row, as the create/update endpoints return it
export const accountTotalResponseSchema = z.object({
  id: z.string().guid(),
  accountId: z.string().guid(),
  balance: z.number(),
  source: z.string(),
  sourceId: z.string().guid().nullable(),
  date: z.coerce.date(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type AccountTotalResponseDto = z.infer<typeof accountTotalResponseSchema>
